
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.018.004c2.478 0 4.854 1.05 6.606 2.917 1.752 1.868 2.736 4.402 2.736 7.044 0 7.617-6.045 14.062-9.342 14.062-3.297 0-9.342-6.445-9.342-14.062 0-2.642.984-5.176 2.736-7.044C5.164 1.053 7.54.004 10.018.004zm6.045 11.719c-.693 0-1.38.155-2.013.456-.633.3-1.2.74-1.664 1.29a5.367 5.367 0 00-1.028 1.901 5.605 5.605 0 00-.213 2.182 4.687 4.687 0 002.535-.427c.633-.3 1.2-.74 1.664-1.29a5.367 5.367 0 001.028-1.9 5.605 5.605 0 00.213-2.183 5.146 5.146 0 00-.522-.03zm-12.09 0c-.176 0-.35.01-.522.029a5.6 5.6 0 00.255 2.314 5.331 5.331 0 001.166 1.971c.522.557 1.153.981 1.849 1.243a4.66 4.66 0 002.17.272c.019-.183.028-.369.028-.556 0-1.399-.521-2.74-1.449-3.729-.927-.989-2.185-1.544-3.497-1.544z","fill":"#E7E5EC"}})])
          )
        }
      }
    